export default "__VITE_PUBLIC_ASSET__82605d96__"